import React, { useEffect, useState } from "react";

// reactstrap components
import {
    Carousel,
    CarouselItem,
    CarouselIndicators,
} from "reactstrap";

// core components
import EventCarouselItem from "./EventCarouselItem"
import db from "../../../db"

function EventCarousel({ style, carouselItems, events }) {

    // Checks if events exist, if not, find them
    const [eventsCheck, setEventsCheck] = useState([])
    useEffect(() => !events ? db.Events.listenAll(setEventsCheck) : setEventsCheck(events), [events])

    const [displayed, setDisplayed] = useState([])

    // Filters carouselItems to display only those whose .isDisplayed === true
    useEffect(() => {
        setDisplayed(carouselItems?.filter(item => item.isDisplayed))
    }, [carouselItems])

    // carousel functions
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const onExiting = () => {
        setAnimating(true);
    };
    const onExited = () => {
        setAnimating(false);
    };
    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === displayed.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };
    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? displayed.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };
    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    // Checks if there is only 1 carousel item, if so permanently set the activeIndex to 0
    useEffect(() => {
        if (displayed?.length === 1) {
            setActiveIndex(0)
        }
    }, [displayed])

    return (
        <>
            {/* Carousel */}
            <div className="header-3" style={style}>
                <div className="page-carousel">
                    <div className="filter" />
                    {
                        displayed &&
                        <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                            <CarouselIndicators
                                items={displayed}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex}
                            />
                            {
                                displayed && displayed.map((item) => {
                                    return (
                                        <CarouselItem
                                            onExiting={onExiting}
                                            onExited={onExited}
                                            key={item.id}
                                        >
                                            <EventCarouselItem
                                                {...item}
                                                category={item}
                                                events={eventsCheck?.filter((event) => event.category === item.id)}
                                            />
                                        </CarouselItem>
                                    )
                                })
                            }
                            <a
                                className="left carousel-control carousel-control-prev"
                                data-slide="prev"
                                href="#pablo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    previous();
                                }}
                                role="button"
                            >
                                <span className="fa fa-angle-left" />
                                <span className="sr-only">Previous</span>
                            </a>
                            <a
                                className="right carousel-control carousel-control-next"
                                data-slide="next"
                                href="#pablo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    next();
                                }}
                                role="button"
                            >
                                <span className="fa fa-angle-right" />
                                <span className="sr-only">Next</span>
                            </a>
                        </Carousel>
                    }
                </div>
            </div>
        </>
    );
}

export default EventCarousel;
